import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@/components/common/Loader';
import { LazyDialog } from '@/modules/Dialogs';
import lazyWithRetry from '@/utils/lazyWithRetry';

const ExportMessageDialogContent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "export-dialog" */
    './ExportMessageDialogContent'
  ),
);

export default function ExportMessageDialog({
  headerText,
  onClose,
  open,
  success,
  ...dialogProps
}) {
  const fallback = <Loader isCentered />;

  return (
    <React.Suspense fallback={fallback}>
      <LazyDialog
        onClose={onClose}
        open={open}
        classes={{ paper: 'w-full max-sm' }}
        {...dialogProps}
      >
        <ExportMessageDialogContent
          headerText={headerText}
          onClose={onClose}
          success={success}
        />
      </LazyDialog>
    </React.Suspense>
  );
}

ExportMessageDialog.propTypes = {
  headerText: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  success: PropTypes.bool,
};

ExportMessageDialog.defaultProps = {
  headerText: '',
  onClose: () => {},
  open: false,
  success: false,
};
